import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Model} from './app.model';
import {AuthService} from './auth/auth.service';
import {autorun} from 'mobx';

@Injectable()
export class IsPartnerGuard  {

  constructor(private m: Model, private authService: AuthService, private router: Router) {

  }
  canActivate() {
    let resolve: (boolean) => void;
    const activatePromise = new Promise<boolean>(function(ok) {
      resolve = ok;
    });
    let autosub = null;
    autosub = autorun(() => {
      if (!this.m.account.isInitialized) {
        return;
      }
      if (!this.m.account.currentUser.companyIsPartner) {
        this.router.navigate(['/subscriptions', 'my']);
        resolve(false);
      } else {
        resolve(true);
      }
      if (autosub) {
        autosub();
      }
    });
    return activatePromise;
  }
}
